import { z } from 'zod';

import { PermissionCatalogNodeSchema } from './shared.schemas.js';

export const ListProfileTemplatePermissionsResponseSchema = z.object({
  items: z.array(PermissionCatalogNodeSchema),
});

export type ListProfileTemplatePermissionsResponse = z.infer<
  typeof ListProfileTemplatePermissionsResponseSchema
>;
